import { render } from "./CompletionBadge.vue?vue&type=template&id=3d7483ac"
import script from "./CompletionBadge.vue?vue&type=script&lang=js"
export * from "./CompletionBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__